<template>
    <span v-show="mesInvitations.size==0? false: true"> 
             <span v-if="_props.page=='Profile' || _props.page=='header-notifications'"><sup  class="badge badge-pill bg-danger text-white py-1 font-weight-normal"> {{mesInvitations.size}}</sup> </span>
             <span v-else> <sup> {{mesInvitations.size}} </sup>  </span>
    </span> 
</template>
<script>

    import api from "../../config/_api";

    import { mapGetters } from 'vuex';

    export default {
        name: "NbInvitation",
        data (){
            return{
                nbInvitation : 0,
            }
        },
        props:{
            page : "",
        },
        computed : {
            ...mapGetters({
               mesInvitations: 'adherents/mesInvitations',
            }),
        },
    }
</script>
